import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

import { Content } from './styles'

type Props = PaddingProps

function WhoWeAreSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Content flexDirection={['column', 'column', 'column', 'column', 'row']}>
        <Column>
          {/* /company page h1 (this section opens the page) */}
          <Text as="h1" medium nowrap title title40>
            Who We Are
          </Text>
        </Column>

        <Column
          fullWidth
          maxWidth={['unset', 'unset', 'unset', 'unset', '60%']}
        >
          <Text body body16 mb={9} semiLight>
            StartupCraft began in 2015 as a small group of senior engineers who
            believed execution eats ideas for breakfast. Ten years on, the work
            that keeps coming back is the unglamorous kind: the scheduling, cost
            control, intake and reporting that a business genuinely runs on, and
            that everyone has been meaning to fix for years. We are a small
            senior team by choice — the people scoping your build are the people
            who write it.
          </Text>

          <Text body body16 mb={9} semiLight>
            <Text as="span" medium>
              Our edge?
            </Text>{' '}
            We start by understanding how the work actually happens today, then
            build for the process rather than around it. Sometimes that means
            telling you not to build at all.
          </Text>
        </Column>
      </Content>
    </SectionWrapper>
  )
}

export default WhoWeAreSection
